import { render } from "./Tiles.vue?vue&type=template&id=16c4816a&scoped=true"
import script from "./Tiles.vue?vue&type=script&lang=js"
export * from "./Tiles.vue?vue&type=script&lang=js"

import "./Tiles.vue?vue&type=style&index=0&id=16c4816a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-16c4816a"

export default script